// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3NGbg","subheader":"ReorderModal_subheader__W4Og9","listWrap":"ReorderModal_listWrap__1oRX2"};